/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { OmitFunctions } from 'src/core/stores/types';

export class QnaMakerSynonymStore {
    public readonly id: number;

    @observable public alterations: string[];

    constructor(data: Partial<OmitFunctions<QnaMakerSynonymStore>>) {
        this.id = data.id;
        this.alterations = [...data.alterations];
    }

    @action
    public setalterations(w: string[]) {
        this.alterations = [...w];
    }
}
